import React from 'react';
import { FileTextIcon, AlertTriangleIcon, LayersIcon, UtensilsIcon, ClockIcon } from 'lucide-react';
export function IncludesSection() {
  return <section className="py-12 mb-12 bg-amber-50 rounded-lg" data-id="element-219">
      <div className="max-w-3xl mx-auto" data-id="element-220">
        <h2 className="text-2xl md:text-3xl font-serif font-bold text-center text-amber-900 mb-8" data-id="element-221">
          Lo Que Incluye
        </h2>
        <p className="text-lg text-amber-800 text-center font-medium mb-8" data-id="element-222">
          Todo Lo Que Necesitas Para Dominar la Milhojas
        </p>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8" data-id="element-223">
          <div className="bg-white p-6 rounded-lg shadow-sm flex flex-col items-center" data-id="element-224">
            <FileTextIcon size={36} className="text-amber-600 mb-4" data-id="element-225" />
            <h3 className="text-lg font-bold text-amber-900 mb-2" data-id="element-226">
              Receta paso a paso de la masa
            </h3>
            <p className="text-gray-700 text-center" data-id="element-227">¡Sin complicaciones!</p>
          </div>
          <div className="bg-white p-6 rounded-lg shadow-sm flex flex-col items-center" data-id="element-228">
            <AlertTriangleIcon size={36} className="text-amber-600 mb-4" data-id="element-229" />
            <h3 className="text-lg font-bold text-amber-900 mb-2" data-id="element-230">
              Secretos para que las capas no se inflen
            </h3>
            <p className="text-gray-700 text-center" data-id="element-231">En el horno</p>
          </div>
          <div className="bg-white p-6 rounded-lg shadow-sm flex flex-col items-center" data-id="element-232">
            <LayersIcon size={36} className="text-amber-600 mb-4" data-id="element-233" />
            <h3 className="text-lg font-bold text-amber-900 mb-2" data-id="element-234">
              Cómo armar y rellenar la torta
            </h3>
            <p className="text-gray-700 text-center" data-id="element-235">
              Para que quede alta y pareja
            </p>
          </div>
          <div className="bg-white p-6 rounded-lg shadow-sm flex flex-col items-center" data-id="element-236">
            <UtensilsIcon size={36} className="text-amber-600 mb-4" data-id="element-237" />
            <h3 className="text-lg font-bold text-amber-900 mb-2" data-id="element-238">
              Receta del merengue italiano
            </h3>
            <p className="text-gray-700 text-center" data-id="element-239">
              Para el acabado perfecto
            </p>
          </div>
          <div className="bg-white p-6 rounded-lg shadow-sm flex flex-col items-center md:col-span-2" data-id="element-240">
            <ClockIcon size={36} className="text-amber-600 mb-4" data-id="element-241" />
            <h3 className="text-lg font-bold text-amber-900 mb-2" data-id="element-242">
              Consejos de conservación y presentación
            </h3>
            <p className="text-gray-700 text-center" data-id="element-243">
              Para mantener tu milhojas perfecta por más tiempo
            </p>
          </div>
        </div>
      </div>
    </section>;
}